// import { Card } from "../../types/Card";
// import { CardFormValues } from "../../types/Card";

import { APIResponseType } from "../../types/generics/APIResponse.type";
import axios from "axios";
import { Talent } from "../../types/user";
import { CardFormValues, CategoriesValue } from "../../types/Card";
import {
  createDeleteApiHook,
  createGetApiHook,
  tokenSourceFn,
  createPostApiHook,
} from "./apiHooks";
import { API_BASE_URL } from "./axiosConfig";

type cardQueryParams = Record<string, any>;

const getAllCardAPI = (queryParams: cardQueryParams = {}): string => {
  const fullParams = {
    ...queryParams,
    offset: queryParams.offset ?? 0,
    limit: queryParams.limit ?? 1000,
  };

  const queryString = new URLSearchParams(fullParams).toString();
  return `/taas-cards?${queryString}`;
};

const getCloverCardPurchaseList = (queryParams: cardQueryParams = {}): string => {
  const fullParams = {
    ...queryParams,
    offset: queryParams.offset ?? 0,
    limit: queryParams.limit ?? 1000,
  };

  const queryString = new URLSearchParams(fullParams).toString();
  return `/taas-cards/clover/purchase?${queryString}`;
};


const getOnAirCardAPI = (queryParams: cardQueryParams = {}) => {
  const fullParams = {
    ...queryParams,
    offset: queryParams.offset ?? 0,
    limit: queryParams.limit ?? 1000,
  };

  const queryString = new URLSearchParams(fullParams).toString();
  return `/taas-cards/on-air?${queryString}`;
};

const getAllInstantBookingCardAPI = (queryParams: cardQueryParams = {}): string => {
  const fullParams = {
    ...queryParams,
    offset: queryParams.offset ?? 0,
    limit: queryParams.limit ?? 1000,
  };

  const queryString = new URLSearchParams(fullParams).toString();
  return `/taas-cards/instance-booking?${queryString}`;
};

// const getAllCardAPI = `/taas-cards`;
const POSTCardAPI = `/taas-cards`;
export type CardWithTalent = CardFormValues & {
  talent: Talent;
};

export type CardWithTalent_updated = CardFormValues & {
  talent: Talent;
}; // All the fields from cardFormValues and plus one additional fields

const getCardById = ({ id }: { id: number }) => `/taas-cards/${id}`;
const getStageCardById = ({ id }: { id: number }) => `/taas-cards/stage/${id}`;

const cloverCardPurchase = ({ id }: { id: number }) =>
  `/taas-cards/clover/${id}/purchase`;

const deactivateCard = ({ id }: { id: string }) =>
  `/taas-cards/deactivate/${id}`;

const purchaseCard = ({ id }: { id: number }) => `/taas-cards/purchase/${id}`;
const onAirCard = "/taas-cards/on-air";

const downloadDiamondCard = ({ id }: { id: string }) =>
  `/taas-cards/download/${id}`;



export const useGetAllCard = createGetApiHook<
  APIResponseType<CardWithTalent[]>,
  {}
>(getAllCardAPI);

export const useGetAllInstantBookingCard = createGetApiHook<
  APIResponseType<CardWithTalent[]>,
  {}
>(getAllInstantBookingCardAPI);

export const useGetOnAirCard = createGetApiHook<
  APIResponseType<CardWithTalent[]>,
  { limit: number; offset: number }
>(getOnAirCardAPI);

export const useCreateTaasCard = createPostApiHook<
  {},
  {},
  APIResponseType<CardFormValues>
>(POSTCardAPI, {
  isFormDataMethod: false,
});
export const useCreateTaasCard_updated = createPostApiHook<
  {},
  {},
  APIResponseType<CardFormValues>
>(POSTCardAPI, {
  isFormDataMethod: false,
});

export const useGetStageCard = createGetApiHook<
  APIResponseType<CardWithTalent>,
  { id: number }
>(getStageCardById);

export const useUpdateTaasCard = createPostApiHook<
  {}, // 1. Request body (empty object = no body)
  { id: number }, // url path params ( in this id is passed in the URl )
  APIResponseType<CardFormValues> // 3. Expected API response type
>(getCardById, {
  isFormDataMethod: false,
});

export const useDeleteCard = createDeleteApiHook<
  { id: number; talent_id: string },
  { id: number },
  APIResponseType<CardWithTalent>
>(getCardById, {
  isFormDataMethod: false,
});

export const useCloverCardPurchaseList = createGetApiHook<
  APIResponseType<CardWithTalent[]>,
  {}
>(getCloverCardPurchaseList);

export const useDeactivateTaasCard = createPostApiHook<
  { talent_id: string },
  { id: string },
  APIResponseType<CardFormValues>
>(deactivateCard, {
  isFormDataMethod: false,
});

const pvlcEventUrl = ({ id }: { id: string }) => `/taas-cards/${id}/pvlc-status`;

export const useChangePvlcStatus = createPostApiHook<
  {},
  { id: string },
  APIResponseType<any>
>(pvlcEventUrl, {
  isFormDataMethod: false,
});

export const useBookmarkCard = createPostApiHook<
  { card_id?: number }, // ✅ Body: what backend expects
  {}, // ✅ No URL/query parameters
  APIResponseType<CardFormValues>
>("/taas-cards/bookmark", {
  isFormDataMethod: false,
});

export const useAddToDeckCard = createPostApiHook<
  { card_id?: number }, // ✅ Body: what backend expects
  {}, // ✅ No URL/query parameters
  APIResponseType<CardFormValues>
>("/taas-cards/deck", {
  isFormDataMethod: false,
});

export const useGetCategories = createGetApiHook<
  APIResponseType<CategoriesValue[]>,
  {}
>(`/categories`);

export const usePurchaseCard = createPostApiHook<
  {},
  { id: number },
  APIResponseType<CardFormValues>
>(purchaseCard, {
  isFormDataMethod: false,
});

export const useDownloadDiamondCard = createPostApiHook<
  {},
  { id: string },
  APIResponseType<Blob>
>(downloadDiamondCard, {
  isFormDataMethod: false,
});

export const useCloverPurchaseCard = createPostApiHook<
  {},
  { id: number },
  APIResponseType<CardFormValues>
>(cloverCardPurchase, {
  isFormDataMethod: false,
});

export const cloverEventStartEnd = async (
  talentId: number,
  cardId: string,
  path: "start" | "end"
) => {
  try {
    const response = await axios.post(
      API_BASE_URL + `/taas-cards/clover/${cardId}/${path}`,
      {},
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "talent-id": talentId,
          Authorization: `Bearer ${tokenSourceFn()}`,
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const useGetTaasCard = createGetApiHook<
  APIResponseType<CardWithTalent>,
  { id: number }
>(getCardById);

// Utility hook to get card name by ID from all fetched cards
export const useCardName = () => {
  const {
    data: cardData,
    isLoading,
    error,
  } = useGetAllCard({
    key: ["taas-cards"],
  });

  const getCardById = (card_id: string | number) => {
    return cardData?.data.find((b) => String(b.id) === String(card_id));
  };

  return {
    getCardById,
    isLoading,
    error,
  };
};
